import { useEffect, useRef, useState } from "react";

interface Props {
  initialSpeaker: string | null;
  initialText: string;
  onSave: (speaker: string | null, text: string) => void;
  onCancel: () => void;
}

export function MessageEditor({ initialSpeaker, initialText, onSave, onCancel }: Props) {
  const [isNarration, setIsNarration] = useState(initialSpeaker === null);
  const [speaker, setSpeaker] = useState(initialSpeaker ?? "");
  const [text, setText] = useState(initialText);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    textareaRef.current?.focus();
    textareaRef.current?.select();
  }, []);

  const save = () => {
    onSave(isNarration ? null : speaker, text);
  };

  return (
    <div className="modal-backdrop" onMouseDown={onCancel}>
      <div className="modal" onMouseDown={(e) => e.stopPropagation()}>
        <h2>メッセージ編集</h2>

        <label className="modal-checkbox">
          <input
            type="checkbox"
            checked={isNarration}
            onChange={(e) => setIsNarration(e.target.checked)}
          />
          <span>地の文(話者なし)</span>
        </label>

        {!isNarration && (
          <label>
            話者
            <input
              type="text"
              value={speaker}
              onChange={(e) => setSpeaker(e.target.value)}
              placeholder="例: アリス"
              autoFocus
            />
          </label>
        )}

        <label>
          本文 <small>(改行で複数行)</small>
          <textarea
            ref={textareaRef}
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows={6}
            placeholder="メッセージ本文…"
          />
        </label>

        <div className="modal-hint">
          <code>[ruby 漢字 ふり]</code> / <code>[color=#FF0000]…[/color]</code> /{" "}
          <code>[wait 200]</code> などのインラインタグも書けます。
        </div>

        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onCancel}>
            キャンセル
          </button>
          <button className="btn btn-primary" onClick={save}>
            保存(Ctrl+Enter)
          </button>
        </div>
      </div>
    </div>
  );
}
